'use client';

import React from 'react';
import Image from 'next/image';
import Script from 'next/script';
import { Flex } from '@mezzoforte/forge';
import { useOpRahoitus } from '@/features/EntryPage/FinancingOptions/OPRahoitus/hooks/useOpRahoitus';
import OPRahoitusButton from '@/features/EntryPage/FinancingOptions/OPRahoitus/OPButton';
import { getWidgetUrl } from '@/features/EntryPage/FinancingOptions/OPRahoitus/util/op-laskuri';
import icon from '@/features/EntryPage/FinancingOptions/icons/osuuspankki.svg';

interface OPCalculatorProps {
  readonly maxPrice: number;
  readonly calculatorType: 'product';
  readonly entryId: number;
  readonly entryCategoryName: string;
}

function OPRahoitusLaskuri({ calculatorType, maxPrice, entryId, entryCategoryName }: OPCalculatorProps) {
  const { currentPrice, loan } = useOpRahoitus(calculatorType, maxPrice);

  return (
    <>
      <Script
        id="op-widget-script-css"
        strategy="lazyOnload"
        stylesheets={[`${getWidgetUrl()}/op-calc-widget.css`]}
      />
      <Flex
        fontSize="sm"
        flex="1 0 100%"
      >
        <Flex mr={2}>
          <Image
            src={icon} // eslint-disable-line @typescript-eslint/no-unsafe-assignment
            alt=""
            width={20}
            height={20}
          />
        </Flex>
        <OPRahoitusButton
          analyticData={{ entryId, category: entryCategoryName, currentPrice }}
          {...loan}
        />
      </Flex>
    </>
  );
}

export default OPRahoitusLaskuri;
